<template>
  <div class="row q-my-lg rule-code-generator">
    <div class="col-8">
      <q-select :modelValue="categories"
                @update:modelValue="updateCategories"
                name="categories[]"
                :options="categoryOptions"
                option-disable="disabled"
                label="Categorie"
                class="text-neutral-90"
                multiple
                use-chips
                required
                :error-message="$errorMessage('categories')"
                :error="$hasError('categories')">
        <template v-slot:selected-item="scope">
          <q-chip
              dense
              :removable="editableCategories.includes(scope.opt.value)"
              @remove="scope.removeAtIndex(scope.index)"
              :tabindex="scope.tabindex"
              class="common-chip"
              :class="{'common-chip--filled': scope.index === 0}"
          >
            {{ scope.opt.label }}
          </q-chip>
        </template>
      </q-select>
      <q-select :modelValue="phases"
                @update:modelValue="updatePhases"
                name="phases[]"
                :options="phaseOptions"
                label="Projectfase"
                class="text-neutral-90"
                multiple
                use-chips
                required
                :error-message="$errorMessage('phases')"
                :error="$hasError('phases')">
        <template v-slot:selected-item="scope">
          <q-chip
              dense
              removable
              @remove="scope.removeAtIndex(scope.index)"
              :tabindex="scope.tabindex"
              class="common-chip"
              :class="{'common-chip--filled': scope.index === 0}"
          >
            {{ scope.opt.label }}
          </q-chip>
        </template>
      </q-select>
    </div>
    <div class="col-4 rule-code-generator__code">
      <q-input borderless
               :modelValue="code"
               @update:model-value="updateCode($event)"
               name="code"
               :placeholder="generateCode ? '' : 'Richtlijn code'"
               :error-message="$errorMessage('code')"
               :error="$hasError('code')"
      />
    </div>
  </div>
  <input :value="leadingCategoryId"
         type="hidden"
         name="leading_category_id">
</template>

<script>

export default {
  props: {
    code: {
      type: String,
      default: null,
    },
    leadingCategoryId: {
      type: Number,
      default: null,
    },
    phases: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
    allPhases: {
      type: Object,
      default: null,
    },
    allCategories: {
      type: Object,
      default: null,
    },
    editableCategories: {
      type: Object,
      default: null,
    },
    generateCode: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    categoryOptions () {
        return this.allCategories.map(category => ({
        value: category.id,
        label: category.title,
        disabled: !this.editableCategories.includes(category.id),
        rule_code_letters: category.rule_code_letters,
      }))
    },
    phaseOptions () {
      return this.allPhases.map(phase => ({
        value: phase.id,
        label: phase.title,
        rule_code_letters: phase.rule_code_letters,
      }))
    },
  },
  emits: [
    'update:phases',
    'update:categories',
    'update:leadingCategoryId',
    'update:code',
  ],
  methods: {
    updatePhases (value) {
      this.$emit('update:phases', value)
      this.findNextAvailableDigit()
    },
    updateCategories (value) {
      this.$emit('update:categories', value)
      if (value.length > 0) {
        this.$emit('update:leadingCategoryId', value[0].value)
      } else {
        this.$emit('update:leadingCategoryId', null)
      }
      this.findNextAvailableDigit()
    },
    updateCode (code) {
      this.$emit('update:code', code)
    },
    async findNextAvailableDigit () {
        await this.$nextTick()
      if (!this.generateCode) return
      if (this.categories.length === 0 || this.phases.length === 0) {
        this.updateCode('')
          return
      }

      const route = this.$route('api.rule.next_available')
      const categoryCode = this.categories[0].rule_code_letters
      const phaseCode = this.phases[0].rule_code_letters
      try {
        const { data } = await axios.get(`${route}/${categoryCode}-${phaseCode}`)
        const digit = data.next
        this.updateCode(`${categoryCode}-${phaseCode}-${digit}`)
      } catch (e) {
        console.error(e)
      }
    },
  },
}
</script>
